import { create } from "zustand";

import { type SessionState } from "..";

export interface SessionStore {
	readonly sessionState: SessionState | undefined;
	setSessionState: (session: SessionState | undefined) => void;
	getSessionState: () => SessionState | undefined;
}

export const useSessionStore = create<SessionStore>((set, get) => {
	return {
		sessionState: undefined,
		setSessionState: (context: SessionState | undefined): void => {
			set({
				sessionState: context
			});
		},

		getSessionState: (): SessionState | undefined => {
			return get().sessionState;
		}
	};
});
